﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { permits } from '../../_Shared/Scripts/Endpoints';
import { createConfirm } from '../../../../resources/scripts/_shared/confirm';

function myAimoParkPreliminaryOrderPage(context) {
  const approveButtons = context.querySelectorAll('.approve__buttons button');

  if (!approveButtons.length) return;
  
  const lang = document.querySelector('html').getAttribute('lang');

  const approveOrder = async (e) => {
    const orderId = e.target.dataset.orderId;
    const myAimoParkStartPageBlock = e.target.closest('.myaimoparkstartpage__block');
    const preliminaryOrderList = e.target.closest('.myaimoparkpreliminaryorder__list');
    const entryLink = preliminaryOrderList.nextElementSibling.querySelector('A');
    let counter = entryLink ? +entryLink.innerText.match(/\d/g)[0] : null;

    const errorSettings = {
      close: preliminaryOrderList.dataset.confirmCloseText,
      cancel: null,
      confirm: preliminaryOrderList.dataset.confirmOkText
    };

    const response = await permits.approvePreliminaryOrder({ orderId }, lang);

    if (response.status == 200) {
      setTimeout(() => {
        if (preliminaryOrderList.querySelectorAll('LI').length === 1 && myAimoParkStartPageBlock) myAimoParkStartPageBlock.remove();
        else if (preliminaryOrderList.querySelectorAll('LI').length === 1) preliminaryOrderList.innerHTML = '';
        else e.target.parentNode.parentNode.remove();
        if (myAimoParkStartPageBlock && counter) entryLink.innerText = entryLink.innerText.replace(/\(.*?\)/, `(${--counter})`)
      }, 500);
      location.reload();
    } else {
      const errorMessage = response.body.ErrorMessage || preliminaryOrderList.dataset.confirmErrorText;
      createConfirm(preliminaryOrderList.dataset.confirmErrorHeading, errorMessage.includes('</strong>') ? errorMessage.split('</strong>')[1] : errorMessage, errorSettings, () => { return })
    }
  };

  for (let i = 0; i < approveButtons.length; i++) {
    approveButtons[i].addEventListener('click', approveOrder);
  };
};

controller.add('myaimopark-preliminary-order-page', myAimoParkPreliminaryOrderPage);